import React from 'react'
import { Box } from '@chakra-ui/core'

const PageWrapper = (props) => <Box maxW="1200px" mx="auto" {...props}>
    {props.children}
</Box>

export default PageWrapper
